export default {
  title: 'Carrello',
};
